const MenteeRegistrationStepper = () => (
    <ol className="mreg-stepper" aria-label="Registration progress">
        <li className="mreg-step is-done">
            <span className="mreg-step-dot" aria-hidden="true">
                ✓
            </span>
            <span className="mreg-step-label">Basic Info</span>
        </li>
        <li className="mreg-step is-active" aria-current="step">
            <span className="mreg-step-dot" aria-hidden="true">
                2
            </span>
            <span className="mreg-step-label">Career Interests</span>
        </li>
        <li className="mreg-step">
            <span className="mreg-step-dot" aria-hidden="true">
                3
            </span>
            <span className="mreg-step-label">Submit</span>
        </li>
    </ol>
);

export default MenteeRegistrationStepper;
